
import axios from "axios"
import { ADD_PRODUCT_SUCCESS, ADD_User_SUCCESS, GET_PRODUCT_SUCCESS, GET_User_SUCCESS, GET_Video_SUCCESS, PATCH_PRODUCT_SUCCESS, PATCH_User_SUCCESS, PRODUCT_FAILURE, PRODUCT_REQUEST } from "./actionType"






export const changeRole = (data,userId) => (dispatch) => {
    const token = JSON.parse(localStorage.getItem('user'))?.token || "";
    dispatch({ type: PRODUCT_REQUEST });
    fetch(`${process.env.REACT_APP_API_URL}/api/auth/Teachme/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      // GET requests don't have a body, so no need to stringify data
    })
      .then((res) => res.json())
      .then((res) => {
        dispatch({ type: ADD_PRODUCT_SUCCESS, payload: res.data });
      })
      .catch((e) => console.log(e));
};

export const getTeacherCourses = () => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token || "";
  dispatch({ type: PRODUCT_REQUEST });
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/courses/teacher/my-courses`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    dispatch({ type: GET_PRODUCT_SUCCESS, payload: res.data.course });
  } catch (e) {
    console.log(e);
    dispatch({ type: PRODUCT_FAILURE });
  }
};

export const addProduct=(data)=> async (dispatch)=>{
  const token = JSON.parse(localStorage.getItem('user'))?.token || "";
  dispatch({type:PRODUCT_REQUEST})
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/courses`,{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
        Authorization:`Bearer ${token}`
      },
      body:JSON.stringify(data)
    });
    const result = await res.json();
    if (!res.ok) throw new Error(result.message || 'Failed to add course');
    dispatch({type:ADD_PRODUCT_SUCCESS,payload:result});
    return result;
  } catch (e) {
    console.log(e);
    dispatch({type:PRODUCT_FAILURE});
    throw e;
  }
}

export const addUser=(data)=>(dispatch)=>{
  const token = JSON.parse(localStorage.getItem('user'))?.token || "";
  dispatch({type:PRODUCT_REQUEST})
  fetch(`${process.env.REACT_APP_API_URL}/api/auth/register`,{
    method:"POST",
    headers:{
      "Content-Type":"application/json",
      Authorization:`Bearer ${token}`
    },
    body:JSON.stringify(data)
  }).then(res=>res.json()).then((res)=>{console.log("userData",res);
      dispatch({type:ADD_User_SUCCESS,payload:res})
  }).catch(e=>console.log(e))
}
export const addSection=(courseId, data)=> async (dispatch)=>{
  const token = JSON.parse(localStorage.getItem('user'))?.token || "";
  dispatch({type:PRODUCT_REQUEST})
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/courses/${courseId}/sections`,{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
        Authorization:`Bearer ${token}`
      },
      body:JSON.stringify(data)
    });
    const result = await res.json();
    if (!res.ok) throw new Error(result.message || 'Failed to add section');
    dispatch({type:PATCH_PRODUCT_SUCCESS,payload:result});
    return result;
  } catch (e) {
    console.log(e);
    dispatch({type:PRODUCT_FAILURE});
    throw e;
  }
}

export const deleteSection=(courseId, sectionId)=>(dispatch)=>{
  const token = JSON.parse(localStorage.getItem('user'))?.token || "";
  dispatch({type:PRODUCT_REQUEST})
  axios.delete(`${process.env.REACT_APP_API_URL}/api/courses/${courseId}/sections/${sectionId}`,{
    headers:{
      Authorization:`Bearer ${token}`
    }
  }).then((res)=>{
    console.log("Section deleted",res);
    dispatch({type:ADD_PRODUCT_SUCCESS,payload:res.data})
  }).catch(e=>dispatch({type:PRODUCT_FAILURE}))
}


export const getProduct=(page,limit,search,order)=>(dispatch)=>{
    const token = JSON.parse(localStorage.getItem('user'))?.token || "";
    dispatch({type:PRODUCT_REQUEST})
    axios.get(`${process.env.REACT_APP_API_URL}/api/courses?page=${page}&limit=${limit}&q=${search}&sortBy=price&sortOrder=${order}`,{
      headers:{
        Authorization:`Bearer ${token}`
      }
    }).then((res)=>{console.log("getProduct",res);
    dispatch({type:GET_PRODUCT_SUCCESS,payload:res.data.course})
    }).catch(e=>dispatch({type:PRODUCT_FAILURE}))
   
}
export const getUser=(page,limit,search,order)=>(dispatch)=>{
    const token = JSON.parse(localStorage.getItem('user'))?.token || "";
    dispatch({type:PRODUCT_REQUEST})
    axios.get(`${process.env.REACT_APP_API_URL}/api/auth?page=${page}&limit=${limit}`,{
      headers:{
        Authorization:`Bearer ${token}`
      }
    }).then((res)=>{console.log("getUsers",res);
    dispatch({type:GET_User_SUCCESS,payload:res.data.users})
    }).catch(e=>dispatch({type:PRODUCT_FAILURE}))
   
}
export const getvideo=(page,limit,user)=>(dispatch)=>{
    const token = JSON.parse(localStorage.getItem('user'))?.token || "";
    dispatch({type:PRODUCT_REQUEST})
    axios.get(`${process.env.REACT_APP_API_URL}/api/videos?page=${page}&limit=${limit}&user=${user}`,{
      headers:{
        Authorization:`Bearer ${token}`
      }
    }).then((res)=>{console.log("getVideos",res.data);
    dispatch({type:GET_Video_SUCCESS,payload:res.data})
    }).catch(e=>dispatch({type:PRODUCT_FAILURE}))
   
}

export const patchProduct=(id,data)=>(dispatch)=>{
  const token = JSON.parse(localStorage.getItem('user'))?.token || "";
  dispatch({type:PRODUCT_REQUEST})
  fetch(`${process.env.REACT_APP_API_URL}/api/courses/${id}`,{
    method:"PATCH",
    headers:{
      "Content-Type":"application/json",
      Authorization:`Bearer ${token}`
    },
    body:JSON.stringify(data)
  }).then(res=>res.json()).then((res)=>{console.log("patch data is",res);
      dispatch({type:PATCH_PRODUCT_SUCCESS,payload:res})
  }).catch(e=>console.log(e))
}
export const patchUser=(id,data)=>(dispatch)=>{
  const token = JSON.parse(localStorage.getItem('user'))?.token || "";
  dispatch({type:PRODUCT_REQUEST})
  fetch(`${process.env.REACT_APP_API_URL}/api/auth/update/${id}`,{
    method:"PATCH",
    headers:{
      "Content-Type":"application/json",
      Authorization:`Bearer ${token}`
    },
    body:JSON.stringify(data)
  }).then(res=>res.json()).then((res)=>{console.log("patch data is",res);
      dispatch({type:PATCH_User_SUCCESS,payload:res})
  }).catch(e=>console.log(e))
}


export const deleteProduct=(id)=>(dispatch)=>{
    const token = JSON.parse(localStorage.getItem('user'))?.token || "";
    dispatch({type:PRODUCT_REQUEST});
    axios.delete(`${process.env.REACT_APP_API_URL}/api/courses/${id}`,{
      headers:{
        Authorization:`Bearer ${token}`
      }
    }).then((res)=>{console.log(res,"deleted");
    dispatch(getProduct(4,3))}).catch(e=>dispatch({type:PRODUCT_FAILURE}))
}
export const deleteUsers=(id)=>(dispatch)=>{
    const token = JSON.parse(localStorage.getItem('user'))?.token || "";
    dispatch({type:PRODUCT_REQUEST});
    axios.delete(`${process.env.REACT_APP_API_URL}/api/auth/delete/${id}`,{
      headers:{
        Authorization:`Bearer ${token}`
      }
    }).then((res)=>{console.log(res,"deleted");
    dispatch(getUser(4,3))}).catch(e=>dispatch({type:PRODUCT_FAILURE}))
}


export default function convertDateFormat(dateString) {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1; 
  const year = date.getFullYear().toString().slice(-2);

  const formattedDate = `${day}/${month}/${year}`;

  if(isNaN(day)){
    return 'No Date Found'
  }

  return formattedDate;
}
